export enum AdminFeatureCategory {
  HEADER = 'header',
  SIDEBAR = 'sidebar',
}
